import { ScanText, ShieldCheck } from 'lucide-react';
import { PRIVACY_STATEMENT } from '../../lib/ocr/constants';

const NAV = [
  ['How it works', '#how-it-works'],
  ['Languages', '#languages'],
  ['Privacy', '#privacy'],
  ['FAQ', '#faq'],
];

export const Header = () => (
  <header className="sticky top-0 z-30 border-b border-[#e6e9f4] bg-white/85 backdrop-blur-xl">
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
      <a
        className="flex items-center gap-3"
        data-testid="header-brand-logo"
        href="#upload"
      >
        <span className="brand-gradient flex h-9 w-9 items-center justify-center rounded-xl text-white shadow-md shadow-indigo-500/25">
          <ScanText aria-hidden="true" className="h-5 w-5" />
        </span>
        <span className="leading-tight">
          <span className="block font-display text-base font-extrabold tracking-tight text-slate-900">
            Text Extractor
          </span>
          <span className="block text-[11px] font-medium text-slate-500">Private Image-to-Text OCR</span>
        </span>
      </a>
      <nav aria-label="Sections" className="hidden items-center gap-1 md:flex">
        {NAV.map(([label, href]) => (
          <a
            className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-[#f2f3fb] hover:text-slate-900"
            href={href}
            key={href}
          >
            {label}
          </a>
        ))}
      </nav>
      <span className="hidden items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-700 sm:inline-flex">
        <ShieldCheck aria-hidden="true" className="h-3.5 w-3.5" />
        Local processing
      </span>
    </div>
  </header>
);

export const Hero = () => (
  <section className="pt-10 sm:pt-14" data-testid="hero-section">
    <p className="text-xs font-bold uppercase tracking-[0.18em] text-indigo-700">Free · No sign-up · No uploads</p>
    <h1 className="mt-3 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
      Turn images into <span className="brand-text">editable text</span> without leaving your browser.
    </h1>
    <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">
      Text Extractor reads photographs of documents, screenshots, WhatsApp images, posters and scanned PDFs in
      English, Hindi and Sanskrit — including light text on dark backgrounds. Recognition runs on your own
      device.
    </p>
    <div
      className="mt-6 inline-flex items-start gap-2.5 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm font-medium text-emerald-800"
      data-testid="privacy-assurance-banner"
    >
      <ShieldCheck aria-hidden="true" className="mt-0.5 h-4.5 w-4.5 shrink-0" />
      <span>{PRIVACY_STATEMENT}</span>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="mt-16 border-t border-[#e6e9f4] bg-white">
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="font-display text-base font-extrabold tracking-tight text-slate-900">Text Extractor</p>
          <p className="mt-1 text-sm text-slate-500">Private Image-to-Text OCR</p>
          <p className="mt-4 max-w-md text-xs leading-relaxed text-slate-500">{PRIVACY_STATEMENT}</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-5 gap-y-2">
          {NAV.map(([label, href]) => (
            <a className="text-sm font-medium text-slate-600 hover:text-slate-900" href={href} key={href}>
              {label}
            </a>
          ))}
        </nav>
      </div>
      <div className="mt-8 flex flex-wrap items-center justify-between gap-3 border-t border-[#eef0f7] pt-5">
        <p className="text-xs text-slate-400" data-testid="footer-wstech-label">
          A WSTech Tool
        </p>
        <p className="text-xs text-slate-400">Accuracy varies by image. Always review extracted text.</p>
      </div>
    </div>
  </footer>
);
